// prettier-ignore
export const getDatetime = (
	param?: {
		dateInput?: string | Date,
		format?: string
	}
): string => {
	let dateInput = param?.dateInput;
	if (!dateInput) {
		dateInput = new Date();
	}
	let format = param?.format;
	if (!format) {
		format = 'YYYY-MM-DD HH:mm:ss';
	}
	const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');

	return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (token) => {
		switch (token) {
			case 'YYYY':
				return String(year);
			case 'MM':
				return month;
			case 'DD':
				return day;
			case 'HH':
				return hours;
			case 'mm':
				return minutes;
			case 'ss':
				return seconds;
			default:
				return token;
		}
	});
};
